// pages/index.js
// Yuan Wang
// Copyright American Marine Research Company LLC 2019

import React, { Fragment, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Image from 'material-ui-image';
import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Fade from 'react-reveal/Fade';
import config from 'react-reveal/globals';
import Divider from '@material-ui/core/Divider';
import Footer from '../components/Footer'
import { Helmet } from "react-helmet"
import LeadForm, { PERKS_FORM_NAME } from '../apps/LeadForm'
import Bar from '../components/Bar'
import HowItWorks from '../components/HowItWorks'
import main_image from '../assets/icons/basic.png'
import package_handoff from '../assets/icons/basic.png'
import Button from '../components/Button';
import Emoji from '../components/Emoji'
import { MainLogo } from '../components/Logo'
import SponsorPanel from '../components/SponsorPanel'

config({ ssrFadeout: true });

const useStyles = makeStyles((theme) => 
  createStyles({
    container: {
      flex: 1,
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      flexDirection: 'column',
      height: '100vh'
    },
    body: {
      paddingTop: '20vh',
      paddingBottom: '5vh',
      flex: 1,
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'center',
      flexDirection: 'column',
    },  
    center: {
      alignItems: 'stretch',
      justifyContent: 'center',
      display: 'flex',
      
      fkex: 1,
    },
    centerText: {
      textAlign: 'center'
    },
    divider: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(5),
      marginLeft: '20vw',
      marginRight: '20vw',
    }
  })
)

export default function Index() {
  const classes = useStyles();

  const scrollToAnchor = () => {
    try {
      const anchor = window.location.href.split('#').slice(-1)[0]
      if (anchor) document.getElementById(anchor).scrollIntoView({ behavior: 'smooth' });
    } catch(error) {

    }
  }

  useEffect(() => {
    const timeout = setTimeout(scrollToAnchor, 100);
    // nextActiveIndex(0)
    // Specify how to clean up after this effect:
    return function cleanup() {
      clearTimeout(timeout)
    };
  }, []);

  return (
    <Fragment>
      {/* <Bar/> */}
      <Helmet>
        <meta charSet="utf-8" />
        <title>AMRC</title>
        <link rel="canonical" href="https://amrc.io" />
      </Helmet>
      
        <Container className={classes.container}>
        
          <Container className={classes.body}>
            
            <a href='/' className={classes.center}>
              <MainLogo/>
            </a>
            <Fade delay={1000} duration={2000} cascade>
            <br/>
            <Typography 
              variant="h5"
              className={classes.centerText} 
              component="p" 
              gutterBottom>
              Recalibrating
            </Typography>
            <Typography 
              variant="p"
              className={classes.centerText} 
              component="p" 
              gutterBottom>
              We've had to take a step back due to resource constraints.
              <br/>
              Development continues.
            </Typography>
            <Divider className={classes.divider}/>
            </Fade>

            <Fade delay={3000} duration={2000} cascade>
              <Typography 
                variant="p"
                className={classes.centerText} 
                component="p" 
                gutterBottom>
                Thank you to the organizations and individuals who have supported us on this mission.
              </Typography>
              <br/>
              <SponsorPanel/>
            </Fade>
            
          </Container>
          <Fade delay={5000} duration={2000} cascade>
            <div>
              <Footer/>
            </div>
          </Fade>
        
        </Container>
    </Fragment>
  );
}
